
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';
import { AdvancedSearchController } from 'rt/UIApiControllers/AdvancedSearch/AdvancedSearchController';
import { IFlowTemplateDTO } from 'dto/IFlowTemplateDTO';

@Component({
  name: 'IfSummary',
})
export default class IfSummary extends NodeFormMixin {
  advancedSearchController = new AdvancedSearchController(Vue.axios);

  @Prop() flow: IFlowTemplateDTO;

  description: string = null;

  async mounted() {
    await this.loadDescriptions();
  }

  @Watch('data')
  async handleDataChanges() {
    await this.loadDescriptions();
  }

  async loadDescriptions() {
    if (this.data.action.conditions && this.data.action.reportName) {
      this.description = await this.advancedSearchController.Describe(this.data.action.reportName, this.data.action.conditions);
    } else this.description = null;
  }

  get hasConditions(): boolean {
    if (!this.data.action) {
      return false;
    }
    return this.data.action.conditions && this.data.action.conditions.length;
  }
}
